import * as R from 'ramda'
import { createSelector } from 'reselect'
import * as RE from 'helpers/ramda-ext'
import { getFromLocalStorage } from 'store/reducers/fromLocalStorage'
import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { refreshStoredParticipants } from 'domain/participants'
import { getNbMissingBirthdatesForCategory } from 'domain/pricerParticipants'
import { hasVisibleParticipantsPicker } from 'domain/packages'
import {
  getCapacityConf,
  getParticipantsSettings
} from './pricerCapacity'
import { getActivePackage, getCurrentSelection } from './package'

export const getParticipantsRules = createSelector(
  getParticipantsSettings,
  R.prop('rules')
)

export const getVisibleParticipantsCategories = createSelector(
  getCapacityConf,
  (conf) => (
    PARTICIPANTS_CATEGORIES.reduce((visibleParticipantsCategories, category) => {
      if (conf[category].visible) {
        visibleParticipantsCategories.push(category)
      }
      return visibleParticipantsCategories
    }, [])
  )
)

export const getParticipantsFromLS = createSelector(
  getFromLocalStorage,
  R.pipe(
    R.prop('configurator'),
    RE.whenNotNil(
      R.pipe(
        R.prop('participants'),
        R.defaultTo({}),
        refreshStoredParticipants
      )
    ),
    R.when(
      R.isEmpty,
      R.always(undefined)
    )
  )
)

export const getSelectedParticipants = createSelector(
  getCurrentSelection,
  RE.whenNotNil(R.prop('participants'))
)

export const getParticipants = createSelector(
  getSelectedParticipants,
  getParticipantsFromLS,
  (selectedParticipants, participantsFromLS) => (participantsFromLS || selectedParticipants)
)

export const getIsParticipantsValuesEqualsWithLS = createSelector(
  getSelectedParticipants,
  getParticipantsFromLS,
  (selectedParticipants, participantsFromLS) => (
    (selectedParticipants && participantsFromLS)
      ? R.equals(
        R.pick(PARTICIPANTS_CATEGORIES, selectedParticipants),
        R.pick(PARTICIPANTS_CATEGORIES, participantsFromLS)
      )
      : false
  )
)

const getValues = (data, arr, index = 0) => {
  if (!arr[index]) {
    arr[index] = []
  }

  if (Array.isArray(data)) {
    arr[index].push(...data)
  } else {
    const keys = Object.keys(data)

    keys.forEach(key => {
      arr[index].push(+key)
      getValues(data[key], arr, index + 1)
    })
  }
}

export const getRulesPerCategories = createSelector(
  getParticipantsRules,
  (rules) => {
    const possibilities = []
    getValues(rules, possibilities)
    return possibilities
  }
)

export const getHasVisibleParticipantsPicker = createSelector(
  getActivePackage,
  hasVisibleParticipantsPicker
)

export const getHasParticipantsInLS = createSelector(
  getParticipantsFromLS,
  R.pipe(R.keys, RE.isNotEmpty)
)

export const getNbOfMissingBirthdates = createSelector(
  getSelectedParticipants,
  getCapacityConf,
  (selectedParticipants, conf) => {
    const nbOfMissingAdultsBirthdates = (conf?.adults?.askBirthdays)
      ? getNbMissingBirthdatesForCategory(selectedParticipants.adults)
      : 0
    const nbOfMissingChildrenBirthdates = (conf?.children?.askBirthdays)
      ? getNbMissingBirthdatesForCategory(selectedParticipants.children)
      : 0
    const nbOfMissingBabiesBirthdates = (conf?.babies?.askBirthdays)
      ? getNbMissingBirthdatesForCategory(selectedParticipants.babies)
      : 0

    return nbOfMissingAdultsBirthdates + nbOfMissingChildrenBirthdates + nbOfMissingBabiesBirthdates
  }
)
